import React from "react"
import { HashLink as Link } from "react-router-hash-link"

const HashLink = ({ text, children, ...rest }) => (
  <Link
    {...rest}
    scroll={el => el.scrollIntoView({ behavior: "smooth", block: "start" })}
  >
    {children ? children : text}
  </Link>
)

export default HashLink



// WEBPACK FOOTER //
// ./src/components/HashLink/index.jsx